import { createContext, useContext, useState } from "react";
import { useAtomValue } from "jotai";
import { DocumentVersion } from "@generated/client/graphql";
import { showAiValidationAtom } from "@app/store/versionStore";

export const RegularTabs = { INFO: "INFO", AI_COACH: "AI_COACH" } as const;
type RegularTab = (typeof RegularTabs)[keyof typeof RegularTabs];

export function useCreateDocumentEditorContext(
    version?: DocumentVersion | null,
) {
    const [regularModeActiveTab, setRegularModeActiveTab] =
        useState<RegularTab>(RegularTabs.INFO);
    const [aiCheckLoadingProgress, setAiCheckLoadingProgress] = useState(0);
    const {
        data: { showAiValidation },
        isPending,
    } = useAtomValue(showAiValidationAtom);
    return {
        version,
        regularModeActiveTab,
        setRegularModeActiveTab,
        aiCheckLoadingProgress,
        setAiCheckLoadingProgress,
        displayAiCheckTab:
            !!version?.finalFile && !!showAiValidation && !isPending,
    };
}
export const EditorContext = createContext<ReturnType<
    typeof useCreateDocumentEditorContext
> | null>(null);
export function useEditorContext() {
    const context = useContext(EditorContext);
    if (!context) throw new Error("Document review context is required");
    return context;
}
